var Backbone = require('backbone')
  , _ = require('underscore')
  , tmpl = require('./tmpl.handlebars')
  , enableDialog = require('ui/enableDialog')
  , formUtils = require('@173js/ui/form')
  , ValidateForm = require('widgets/ValidateForm')
  , ued = window.ued || {}
  , openAlert = require('game-info/widgets/openAlert')
  , successTmpl = require('./success.handlebars')

var View = Backbone.View.extend({
  events: {
    'submit form': 'formSubmitted'
  }
, initialize: function(options) {
    options = options || {}
    this.userInfo = options.userInfo || {}
  }
, ajaxSubmitForm: function(dict) {
    var ued = window.ued || {}
      , gameCode = ued.gameCode
      , form = this.form
      , ERROR = '0'
      , ERROR_MESSAGE = '网络发生了错误'

    formUtils.readonlyForm(form)

    return $.ajax({
      type: 'POST',
      url: '/track-updateUserInfo.html',
      dataType:'json',
      data: dict
    }).always(function() {
      formUtils.resumeForm(form)
    }).done(_.bind(function(resp) {
      if (resp.status !== ERROR) {
        this.trigger('close')
        return openAlert({
          html: successTmpl()
        , title: '预订成功'
        })
      }

      this.renderFieldErrors(
        _.map([{ message: resp.msg || ERROR_MESSAGE }])
      )
    }, this))
    .fail(_.bind(function() {
      this.renderFieldErrors(
        _.map([{ message: ERROR_MESSAGE }])
      )
    }, this))
  }
, formSubmitted: function(e) {
    e.preventDefault()
    var dict = formUtils.toDict(this.$('form'))
      , HIDE_ERRORS = []

    this.renderFieldErrors(HIDE_ERRORS)

    if (!this.validateForm.validate()) {
      this.renderFieldErrors(this.validateForm.fieldErrors)
      return
    }

    this.ajaxSubmitForm(dict)
  }
, fetchMemberInfo: function() {
    return $.getJSON('/game-getMemberInfo.html')
  }
, render: function() {
    this.$el.html(tmpl(this.userInfo))

    this.form = this.$('form')
    this.validateForm = new ValidateForm({
      form: this.form
    })

    return this
  }
, renderFieldErrors: function(fieldErrors) {
    // TODO: DRY
    var errorBlock = this.$('.errors-block')
    if (!fieldErrors || !fieldErrors.length) {
      errorBlock.hide()
      return
    }

    errorBlock.empty()

    _.each(fieldErrors, function(x) {
      if (!x.message) { return }
      errorBlock.append('<li>' + x.message + '</li>')
    })

    errorBlock.show()
  }
})

module.exports = enableDialog(View, { title: '预订成功' })
